import axios from "axios";

export default class Service {
    constructor() {
        this.url = "/api/Admin/";
    }

    getTablesInfo() {
        return axios.get(this.url + "GetTablesInfo");
    }

    getAllUsers() {
        return axios.get(this.url + "GetAllUsers");
    }

    getAllGroups() {
        return axios.get(this.url + "GetAllGroups");
    }

    getAllGroupsAndUsers() {
        return axios.get(this.url + "GetAllGroupsAndUsers");
    }

    getAllInvitations() {
        return axios.get(this.url + "GetAllInvitations");
    }

    getAllAuthors() {
        return axios.get(this.url + "GetAllAuthors");
    }

    upsertAuthor(author) {
        return axios.post(this.url + "UpsertAuthor", author);
    }

    getAllCitations() {
        return axios.get(this.url + "GetAllCitations");
    }

    upsertCitation(citation) {
        return axios.post(this.url + "UpsertCitation", citation);
    }

    getAllHobbies() {
        return axios.get(this.url + "GetAllHobbies");
    }

    upsertHobby(hobby) {
        return axios.post(this.url + "UpsertHobby", hobby);
    }

    getAllSports() {
        return axios.get(this.url + "GetAllSports");
    }

    upsertSport(sport) {
        return axios.post(this.url + "UpsertSport", sport);
    }

    getAllFood() {
        return axios.get(this.url + "GetAllFood");
    }

    upsertFood(food) {
        return axios.post(this.url + "UpsertFood", food);
    }

    getAllDesserts() {
        return axios.get(this.url + "GetAllDesserts");
    }

    upsertDessert(dessert) {
        return axios.post(this.url + "UpsertDessert", dessert);
    }
}